/* ============================================================================
 * mensedit-brand-search.js — Searchable Brand facet (Stage 1, 2026-06-15)
 * Injects a search box into the Brand/Vendor filter group and filters the
 * brand list client-side. Critical because Dolce & Gabbana is ~47% of the
 * catalog — shoppers need to type past the flood to reach other houses.
 * Works with Horizon's native facets (list-filter.liquid): finds the vendor
 * facet's <ul class="facets__inputs-list">, prepends an <input type=search>,
 * shows/hides <li> by label, and reveals show-more-hidden items while typing.
 * Re-applies after Horizon re-renders the facets form on each filter change.
 * NOTE: first-draft — facet identification + show-more behaviour validated in
 * the Step-3 theme preview before publish.
 * ========================================================================== */
(function () {
  'use strict';
  var EL = (document.documentElement.lang || '').toLowerCase().indexOf('el') === 0;
  var PLACEHOLDER = EL ? 'Αναζήτηση μάρκας…' : 'Search brands…';

  function isBrandList(ul, panel) {
    var name = (ul.getAttribute('name') || '').toLowerCase();
    var pid = (panel && panel.id || '').toLowerCase();
    return /brand|vendor|μάρκ|οίκο/.test(name) || /vendor|brand/.test(pid);
  }

  function enhance(scope) {
    var lists = (scope || document).querySelectorAll('ul.facets__inputs-list');
    Array.prototype.forEach.call(lists, function (ul) {
      var panel = ul.closest('.facets__panel') || ul.closest('details') || ul.parentNode;
      if (!isBrandList(ul, panel)) return;
      var items = ul.querySelectorAll('li.facets__inputs-list-item');
      if (items.length < 8) return;                       // only worth it for long lists
      var host = ul.parentNode;
      if (!host || host.querySelector('.me-brand-search')) return; // already enhanced

      var input = document.createElement('input');
      input.type = 'search';
      input.className = 'me-brand-search';
      input.placeholder = PLACEHOLDER;
      input.setAttribute('aria-label', PLACEHOLDER);
      input.autocomplete = 'off';
      host.insertBefore(input, ul);

      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        Array.prototype.forEach.call(items, function (li) {
          var label = (li.textContent || '').trim().toLowerCase();
          var match = !q || label.indexOf(q) !== -1;
          li.style.display = match ? '' : 'none';
          if (q) { li.classList.remove('hidden'); li.classList.remove('mobile:hidden'); }
        });
      });
      // keep keystrokes inside the facet (don't let Enter submit/close the panel)
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    });
  }

  function init() { try { enhance(document); } catch (e) { /* no-op */ } }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Horizon swaps the facets form on each filter update — re-enhance on re-render.
  var scheduled = false;
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) {
        if (!scheduled) {
          scheduled = true;
          (window.requestAnimationFrame || window.setTimeout)(function () { scheduled = false; init(); });
        }
        return;
      }
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();
